// extracted by mini-css-extract-plugin
export const footer = "footer-module--footer--eMWRA";
export const footer__inner__links = "footer-module--footer__inner__links--3B2DB";
export const legal = "footer-module--legal--3YH_k";
export const footer__inner = "footer-module--footer__inner--2I2Qr";
export const footer__inner__smallprint = "footer-module--footer__inner__smallprint--KCgXO";